import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO + social share cards (OpenGraph/Twitter). Drop <Seo .../> at the
 * top of any page to control its title/description and link-preview image.
 */
export default function Seo({ title, description, image, type = "website", url }) {
  const fullTitle = title ? `${title} — NOWCOMMAND` : "NOWCOMMAND — Cast out Mammon. Rule over Chronos.";
  const desc =
    description ||
    "A brotherhood for sovereign stewards. Weekly drops, the Sovereign community, and the codes to rule money and time under God.";
  const href = url || (typeof window !== "undefined" ? window.location.href : "");
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {href && <meta property="og:url" content={href} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
